import { ActionButton } from '@emerald-works-nova/components'
import { Collapse, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserEmailUpdateSlice } from '../../../../reducers'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    marginBottom: spacing(2),
    paddingBlock: spacing(3),
    paddingInline: spacing(4),
    background: palette.grey.lighter,
    border: `1px dashed ${palette.grey.dark}`,
    borderRadius: 4
  }
}))

const UserEmailUpdateResults = () => {
  const classes = useStyles()
  const results = useSelector(UserEmailUpdateSlice.selectors.selectResults)
  const reportUrl = useSelector(UserEmailUpdateSlice.selectors.selectReportUrl)
  const dispatch = useDispatch()

  const handleDismiss = () => {
    dispatch(UserEmailUpdateSlice.actions.reset())
  }

  return (
    <Collapse in={!!results}>
      {results && (
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          className={classes.root}
          data-test='email-update-report'
        >
          <Grid item xs>
            <Typography variant='caption'>
              <strong>Email Update Finished</strong>
              <br />
              <strong>{new Date().toLocaleDateString()} - Update Log</strong>
              <br />
              Failed records: {results.failed}
              <br />
              Total users updated: {results.updated}
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            container
            direction='column'
            alignItems='flex-end'
            spacing={2}
          >
            <Grid item>
              <ActionButton
                text='Dismiss'
                noBorder
                onClick={handleDismiss}
                data-test='email-update-dismiss-button'
              />
            </Grid>
            <Grid item>
              <ActionButton
                text='Download CSV File'
                component='a'
                href={reportUrl}
                target='_blank'
                disabled={!reportUrl}
                data-test='email-update-download-report-button'
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Collapse>
  )
}

export default UserEmailUpdateResults
